import uniq from 'lodash/uniq';
import { MotionType } from 'consts/motionType';

type MotionTypesRendererProps = {
  motionTypes: MotionType[];
};
const MotionTypesRenderer: React.FC<MotionTypesRendererProps> = ({ motionTypes }) => {
  const motionOptions = uniq(motionTypes);
  return (
    <div className="flex space-x-2">
      {motionOptions.map((item) => (
        <span key={item}>{item === MotionType.MOVING ? 'Video' : 'Still'}</span>
      ))}
    </div>
  );
};
export default MotionTypesRenderer;
